<ng-container *transloco="let t">
  <ng-container *ngIf="teacher">
    <ng-container *ngIf="teacherResults$ | async as teacherResults; else loadingResults">
      <ng-container *ngIf="teacherResults.length > 0; else noResults">
        <div class="modal-header">
          <div class="results__header">
            <h1 class="results__title">{{ t('pap/teacherResults/title') }}</h1>
            <div class="results__subtitle">
              <div class="form-group results__select-result">
                <ng-select
                  id="teacherResult"
                  [items]="teacherResults"
                  bindValue="dataSetUuid"
                  [placeholder]="t('pap/teacherResults/selectResult')"
                  class="form-control form-control-rounded"
                  [minTermLength]="2"
                  [ngModel]="selectedResultUuid"
                  (ngModelChange)="onResultChange($event, teacherResults)"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.finishedAt | date : 'd. M. yyyy' }}
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.finishedAt | date : 'd. M. yyyy' }}
                  </ng-template>
                </ng-select>
              </div>
              <div class="results__teacher-info">
                <span class="results__teacher-name">{{ teacher.firstName }} {{ teacher.lastName }}</span>
                <span class="results__delimeter">•</span>
                <span class="results__teacher-groups">{{ teacher.groups | formatTeacherGroups }}</span>
              </div>

              <button
                class="btn btn-outline-primary btn-icon btn-rounded"
                *ngIf="selectedResult$ | async"
                (click)="downloadTeacherResult()"
              >
                <isophi-print-download-icon></isophi-print-download-icon> {{ t('shared/printDownload') }}
              </button>
            </div>
          </div>
          <button (click)="activeModal.dismiss(null)" aria-label="Close" class="btn-close-icon" tabindex="-1">
            <i class="material-symbols-rounded">close</i>
          </button>
        </div>
        <div class="modal-body">
          <div class="results__content" *ngIf="selectedResult$ | async; else noResultSelected">
            <isophi-app-bar-chart
              [result$]="selectedResult$"
              [getCategoryMap]="getCategoryMap"
              [getCategoryHierarchy]="getCategoryHierarchy"
              [fetchEvaluationRule]="fetchEvaluationRule"
            >
            </isophi-app-bar-chart>
          </div>
        </div>
        <div class="modal-footer"></div>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-template #loadingResults>
    <div class="text-center w-100 mt-4">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </ng-template>
  <ng-template #noResults>
    <div class="no-results">
      <i class="material-symbols-rounded filled"> search </i>
      <span>{{ t('pap/teacherResults/noResults') }}</span>
    </div>
  </ng-template>
  <ng-template #noResultSelected>
    <div class="no-result-selected">
      {{ t('pap/teacherResults/noResultSelected') }}
    </div>
  </ng-template>
</ng-container>
